// Turn a raw API error into a clean, human message. DRF validation errors can
// surface as the Python repr [ErrorDetail(string='...', code='invalid')] — unwrap
// that so centres never see internal-looking text.
export const errorText = (
  error,
  fallback = 'Something went wrong. Please try again.'
) => {
  let msg = (error && error.message) || ''
  const m = msg.match(/ErrorDetail\(string=['"]([\s\S]*?)['"],\s*code=/)
  if (m) msg = m[1]
  // strip any leftover list/quote wrappers
  msg = msg.replace(/^\[+\s*['"]?/, '').replace(/['"]?\s*\]+$/, '').trim()
  return msg || fallback
}
